// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"373747ef","198":"6afe00d1","498":"ab162619","787":"c565b57b"}[chunkId] + ".chunk.js";
};